import type { EquationDocument, EvaluationResult } from "../equation";

export interface EquationEvaluationOptions {
  readonly signal?: AbortSignal;
}

export interface EquationEvaluator {
  (
    document: EquationDocument<2>,
    options?: EquationEvaluationOptions,
  ): Promise<EvaluationResult<2>>;
  (
    document: EquationDocument<3>,
    options?: EquationEvaluationOptions,
  ): Promise<EvaluationResult<3>>;
}

export function createEvaluationAbortError(): Error {
  const error = new Error("Expression evaluation was cancelled");
  error.name = "AbortError";
  return error;
}

export function isEvaluationAbort(error: unknown): boolean {
  return error instanceof Error && error.name === "AbortError";
}
